/* Veer recently-viewed (2026-07-08) — localStorage, no app.
   Mirrors veer-wishlist.js patterns: shape-validated storage, DOM-API cards (no innerHTML
   for dynamic data), dead-handle prune, section hidden until it has content. */
(function () {
  var KEY = 'veer:recent';
  var CAP = 8;
  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(a)) return [];
      return a.filter(function (x) { return typeof x === 'string' && x.length; }).slice(0, CAP);
    } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, CAP))); } catch (e) {}
  }
  function record(h) {
    var a = read();
    var i = a.indexOf(h);
    if (i > -1) a.splice(i, 1);
    a.unshift(h);
    write(a);
  }
  function buildCard(h, p) {
    var price = ((p.price || 0) / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' lei';
    var imgUrl = p.featured_image
      ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=500'
      : '';
    var card = document.createElement('div');
    card.className = 'veer-wishlist-card';
    var a = document.createElement('a');
    a.className = 'veer-wishlist-card__link';
    a.href = '/products/' + encodeURIComponent(h);
    var media = document.createElement('div');
    media.className = 'veer-wishlist-card__media';
    if (imgUrl) {
      var im = document.createElement('img');
      im.src = imgUrl; im.alt = ''; im.loading = 'lazy';
      media.appendChild(im);
    }
    var title = document.createElement('div');
    title.className = 'veer-wishlist-card__title';
    title.textContent = p.title || '';
    var pr = document.createElement('div');
    pr.className = 'veer-wishlist-card__price';
    pr.textContent = price;
    a.appendChild(media); a.appendChild(title); a.appendChild(pr);
    card.appendChild(a);
    return card;
  }
  function init() {
    var root = document.querySelector('[data-veer-recent]');
    if (!root) return;
    var current = root.getAttribute('data-current-handle') || '';
    var before = read().filter(function (h) { return h !== current; });
    if (current) record(current);
    if (!before.length) return; // nothing to show (first visit) — section stays hidden
    var grid = root.querySelector('[data-veer-recent-grid]');
    var section = root.closest('.veer-recent');
    Promise.all(before.map(function (h) {
      // 404 => dead handle (prune); other failures => transient (KEEP history — never wipe on hiccups)
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? false : null); })
        .catch(function () { return null; });
    })).then(function (products) {
      var shown = 0;
      var dead = [];
      products.forEach(function (p, i) {
        if (p) { grid.appendChild(buildCard(before[i], p)); shown++; }
        else if (p === false) dead.push(before[i]);
      });
      if (dead.length) write(read().filter(function (h) { return dead.indexOf(h) === -1; }));
      if (shown > 0 && section) section.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
